/* eslint-disable array-callback-return */
import React, { Component } from "react";
import TableContent from "../../components/tableCards";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import "./styles.scss";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import CardsService from "../../services/CardsService";
import Spinner from "react-spinner-material";
import Ibge from "../../services/IbgeService";

class Cards extends Component {
  constructor() {
    super();
    this.state = {
      //formAdd
      titulo: "",
      mensagem: "",
      linkBotao: "",
      tituloBotao: "",
      codCnae: "",
      abgTer: "Nacional",
      idEdit: false,
      listCnae: [],
      visualizacao: "dicas_empreendedorismo",

      openModal: false,
      modalStyle: null,

      loading: true,
      loadingAdd: false,
      content: [],

      mensagemError: "",
      erroGetcard: false,
    };
  }

  async componentDidMount() {
    const resultCnaes = await Ibge.getCnaes();
    if (resultCnaes.data) {
      this.setState({ listCnae: resultCnaes.data });
      this.getCards();
    } else {
      this.setState({ erroGetcard: true, loading: false });
    }
  }

  async getCards(params) {
    const content = await CardsService.buscarcards(params);
    try {
      if (content.status === 200) {
        this.setState({ content, loading: false });
      } else {
        this.setState({ erroGetcard: true, loading: false });
      }
    } catch (error) {
      this.setState({ erroGetcard: true, loading: false });
    }
  }

  openAdd = () => {
    this.setState({ openModal: true });
  };

  closeAdd = () => {
    this.setState({
      openModal: false,
      loadingAdd: false,
      cnae: "Todos",
      date: new Date(),
      values: "",
      mensagemError: "",
      idEdit: null,
      titulo: "",
      mensagem: "",
      linkBotao: "",
      tituloBotao: "",
      codCnae: "",
      abgTer: "Nacional",
    });
  };

  addItem = async () => {
    const {
      titulo,
      mensagem,
      linkBotao,
      tituloBotao,
      codCnae,
      abgTer,
      idEdit,
      visualizacao,
    } = this.state;

    this.setState({ loadingAdd: true, mensagemError: "" });

    if (titulo === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Título é obrigatório",
      });
      return false;
    }

    if (mensagem === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Mensagem é obrigatório",
      });
      return false;
    }

    if (linkBotao === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Link do botão é obrigatório",
      });
      return false;
    }

    if (tituloBotao === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Título do botão é obrigatório",
      });
      return false;
    }

    if (codCnae === "") {
      this.setState({ loadingAdd: false, mensagemError: "CNAE é obrigatório" });
      return false;
    }

    if (abgTer === "") {
      this.setState({
        loadingAdd: false,
        mensagemError: "Abrangência Territorial é obrigatório",
      });
      return false;
    }

    let params = {
      titulo: titulo,
      mensagem: mensagem,
      linkBotao: linkBotao,
      tituloBotao: tituloBotao,
      codCnae: codCnae,
      abgTer: abgTer,
      isGlobal: false,
      visualizacao: visualizacao,
      situacao: "CRIADO",
    };

    if (params.codCnae === "Todos") {
      params.codCnae = "00000";
      params.FlagCnae = true;
    } else {
      params.FlagCnae = false;
    }

    if (!idEdit) {
      const res = await CardsService.salvarcard(params);
      if (res.status === 200) {
        this.closeAdd();
        this.setState({ loading: true });
        const content = await CardsService.buscarcards();
        this.setState({ content, loading: false });
      } else {
        this.setState({
          loadingAdd: false,
          mensagemError: "Erro ao cadastrar card, tente mais tarde!",
        });
      }
    } else {
      params.id = idEdit.id;
      const res = await CardsService.editCard(params);
      if (res.status === 200) {
        this.closeAdd();
        this.setState({ loading: true });
        const content = await CardsService.buscarcards();
        this.setState({ content, loading: false });
      } else {
        this.setState({
          loadingAdd: false,
          mensagemError: "Erro ao editar card, tente mais tarde!",
        });
      }
    }
  };

  SimpleModal() {
    let cnaes = [{ value: "Todos", label: "TODOS", selected: true }];

    const listVisualizacao = [
      { value: "dicas_empreendedorismo", label: "Dicas: Empreendedorismo" },
      { value: "dicas_finanças", label: "Dicas: Finanças" },
      { value: "dicas_gestao", label: "Dicas: Gestão" },
      { value: "dicas_mercado", label: "Dicas: Mercado" },
      { value: "dicas_sebrae", label: "Meu Sebrae" },
    ];

    const listAbgr = [
      { value: "Nacional", label: "Nacional" },
      { value: "Estadual", label: "Estadual" },
      { value: "Municipal", label: "Municipal" },
    ];

    this.state.listCnae.map((item) => {
      const valueInsert = {
        value: item.id,
        label: `${item.id} - ${item.descricao}`,
      };
      cnaes.push(valueInsert);
    });

    const handleClose = () => {
      this.setState({ openModal: false, loadingAdd: false });
    };

    makeStyles((theme) => ({
      paper: {
        position: "absolute",
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
      },
    }));

    const handleCnae = (event) => {
      this.setState({ codCnae: event.target.value });
    };

    const handleVisualizacao = (event) => {
      this.setState({ visualizacao: event.target.value });
    };

    const handleTitle = (event) => {
      this.setState({ titulo: event.target.value });
    };

    const handleLink = (event) => {
      this.setState({ linkBotao: event.target.value });
    };

    const handleMessage = (event) => {
      this.setState({ mensagem: event.target.value });
    };

    const handleAbgTer = (event) => {
      this.setState({ abgTer: event.target.value });
    };

    const handleTituloBtn = (event) => {
      this.setState({ tituloBotao: event.target.value });
    };

    const { mensagem, titulo, linkBotao, tituloBotao } = this.state;
    return (
      <Modal
        style={{ padding: 20 }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.state.openModal}
        onClose={handleClose}
        className="modal"
      >
        <div>
          <button onClick={this.closeAdd} className="btnFechar">
            X
          </button>
          <div className="cardBox">
            <Grid container spacing={3} className="modal-header">
              <Grid item xs={12} sm={12}>
                <h2 id="simple-modal-title">Adicionar card</h2>
              </Grid>
              <Grid item xs={12} sm={12}>
                <p id="simple-modal-description">
                  Preencha os campos para adicionar o seu card.
                </p>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={6} sm={6}>
                <FormControl>
                  <InputLabel htmlFor="title">Título</InputLabel>
                  <Input
                    value={titulo}
                    onChange={handleTitle}
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug">
                    Digite o título
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6}>
                <FormControl>
                  <InputLabel htmlFor="age-simple">CNAE</InputLabel>
                  <Select
                    value={this.state.codCnae}
                    onChange={handleCnae}
                    inputProps={{
                      name: "cnae",
                      id: "age-simple",
                    }}
                  >
                    {cnaes.map((option, index) => (
                      <MenuItem key={index} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={6} sm={6}>
                <FormControl>
                  <InputLabel htmlFor="link">Título do Botão</InputLabel>
                  <Input
                    value={tituloBotao}
                    onChange={handleTituloBtn}
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug">Digite o link</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6}>
                <FormControl>
                  <InputLabel htmlFor="link">Link do botão</InputLabel>
                  <Input
                    value={linkBotao}
                    onChange={handleLink}
                    id="title"
                    aria-describedby="title-slug"
                  />
                  <FormHelperText id="title-slug">Digite o link</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={6} sm={6}>
                <FormControl>
                  <InputLabel htmlFor="age-simple">Visualização</InputLabel>
                  <Select
                    value={this.state.visualizacao}
                    onChange={handleVisualizacao}
                    inputProps={{
                      name: "visualizacao",
                      id: "age-simple",
                    }}
                  >
                    {listVisualizacao.map((option, index) => (
                      <MenuItem key={index} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6}>
                <FormControl>
                  <InputLabel htmlFor="age-simple">
                    Abrangência territorial
                  </InputLabel>
                  <Select
                    disabled
                    value={this.state.abgTer}
                    onChange={handleAbgTer}
                    inputProps={{
                      name: "abgTer",
                      id: "age-simple",
                    }}
                  >
                    {listAbgr.map((option, index) => (
                      <MenuItem key={index} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={6} sm={6}>
                <TextField
                  id="outlined-multiline-flexible"
                  label="Mensagem"
                  multiline
                  rowsMax="4"
                  value={mensagem}
                  onChange={handleMessage}
                  margin="normal"
                  helperText="Digite a mensagem"
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <button className="btnAdd" onClick={this.addItem}>
              {!this.state.idEdit ? "Adicionar" : "Salvar"}
            </button>
            <Spinner
              size={30}
              spinnerColor={"#0061c6"}
              spinnerWidth={4}
              visible={this.state.loadingAdd ? true : false}
            />
            <div className={"mensagemError"}>{this.state.mensagemError}</div>
          </div>
        </div>
      </Modal>
    );
  }

  listenCard(value, key) {
    const { content } = this.state;
    if (content.data[key].codCnae === "00000") {
      content.data[key].codCnae = "Todos";
    }
    this.setState({
      titulo: content.data[key].titulo,
      mensagem: content.data[key].mensagem,
      linkBotao: content.data[key].linkBotao,
      tituloBotao: content.data[key].tituloBotao,
      codCnae: content.data[key].codCnae,
      abgTer: content.data[key].abgTer,
      // TODO colocar resposta do servidor para visualizacao
      // visualizacao: content.data[key].visualizacao,
      idEdit: value,
      openModal: true,
    });
  }

  render() {
    const { loading, erroGetcard, content } = this.state;

    if (loading) {
      return <div>Carregando...</div>;
    }
    if (erroGetcard) {
      return <div>Erro de servidor, tente mais tarde!.</div>;
    }

    return (
      <div style={{ padding: 20 }}>
        <Grid container direction="row" justify="flex-end">
          <button className="btnAdd" onClick={() => this.openAdd()}>
            Adicionar
          </button>
        </Grid>
        <TableContent
          editItem={(value, key) => this.listenCard(value, key)}
          content={content}
          rowsTable={[]}
        />

        {this.SimpleModal()}
      </div>
    );
  }
}


export default Cards;
